module.exports = __webpack_public_path__ + "4c1f67f4a56ce582ff5ff7b448a597df.svg";